// extracted by mini-css-extract-plugin
module.exports = {"grid":"order-grid_grid__1pLGN"};